import React, { Component } from 'react';


class PremiumCheckout extends Component {
    render() {
        var validRender = (<div className="row"> </div>);
        return validRender;
    }
}

export default PremiumCheckout


// WEBPACK FOOTER //
// ./src/views/PremiumCheckout/PremiumCheckout.js